import React from 'react'
import LoginSub from '../Components/LoginSub/LoginSub'

function LoginSubPage() {
  return (
    <div>
        <LoginSub></LoginSub>
    </div>
  )
}

export default LoginSubPage